import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-twitter-blog",
  "use": "icon-twitter-blog-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-twitter-blog\"><g clip-path=\"url(#icon-twitter-blog_a)\"><path d=\"m11.911 8.537 7.44-8.47H17.59L11.126 7.42 5.968.067H.017l7.802 11.12-7.802 8.88h1.762L8.6 12.301l5.449 7.766H20M2.415 1.37h2.708l12.465 17.46H14.88\" fill=\"#3C3C3B\" /></g><defs><clipPath id=\"icon-twitter-blog_a\"><path fill=\"#fff\" transform=\"translate(.017)\" d=\"M0 0h19.983v20H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol